/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{O as r}from"../../../chunks/OperatorCut.js";const t=new r;function n(r,n,o){const u=t.execute(!0,r,n,o,null);return Array.from(u)}function o(){return t.supportsCurves()}export{n as execute,o as supportsCurves};
